import {Injectable} from '@angular/core';
import {SaleInvoiceConfigurationModel} from '../../api/entity/saleInvoiceConfiguration.model';
import {
    AbstractFindOneByAttributeService
} from '../../../../../../../core/service/v2/service/findone/abstractFindOneByAttribute.service';
import {SaleInvoiceConfigurationRepository} from './ngrx/saleInvoiceConfiguration.repository';
import {SaleInvoiceConfigurationDataServiceAdapter} from './ngrx/saleInvoiceConfigurationDataService.adapter';

@Injectable()
export class SaleInvoiceConfigurationFindOneByAccountBusinessCodeService extends
    AbstractFindOneByAttributeService<SaleInvoiceConfigurationModel, SaleInvoiceConfigurationModel> {

    constructor(repository: SaleInvoiceConfigurationRepository,
                dataServiceAdapter: SaleInvoiceConfigurationDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    protected getAttributeName(): string {
        return 'accountBusinessCode';
    }
}
